<template>
  <v-card
    color="grey lighten-4"
    :to="item.to"
    class="d-flex flex-column item"
    height="100%"
    flat
  >
    <img
      :src="files + item.img"
      alt="Fotos e Eventos"
      class="d-block item-img"
    />

    <div
      class="
        text-caption text-md-body-1
        grey--text
        text--darken-4
        font-weight-bold
        text-center
        my-auto
        px-3 px-sm-4
        py-3 py-sm-7
      "
    >
      <div class="item-title">
        {{ item.title }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  .item-img {
    aspect-ratio: 16 / 12;
    border-radius: 4px 4px 0 0;
    object-fit: cover;
    -o-object-fit: cover;
    width: 100%;
  }
  .item-title {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>
